export default __webpack_public_path__ + "static/pride_flag-39a9b107a76518ffa33cb81ee99a2d3e.jpg";